// extracted by mini-css-extract-plugin
export default {"PAPanelContainer":"DNakoe5N","PAPageCenterText":"ozVElSbo","PAToggleBar":"oI15anQQ","ToggleButton":"WyYfGFG8","DeselectedToggleButton":"nIQZ5TXL"};